import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CHAT_ENABLED } from '../../../base/flags/constants';
import { getFeatureFlag } from '../../../base/flags/functions';
import { translate } from '../../../base/i18n/functions';
import { IconNexusMessage } from '../../../base/icons/svg';
import { getParticipantById } from '../../../base/participants/functions';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { openChat } from '../../../chat/actions.web';
import { isChatDisabled } from '../../../chat/functions';
import { isButtonEnabled } from '../../../toolbox/functions.web';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
/**
 * A custom implementation of the PrivateMessageButton specialized for
 * the web version of the remote video menu. When the web platform starts to use
 * the {@code AbstractButton} component for the remote video menu, we can get rid
 * of this component and use the generic button in the chat feature.
 */
class PrivateMessageMenuButton extends Component {
    /**
     * Instantiates a new Component instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onClick = this._onClick.bind(this);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _hidden, t } = this.props;
        if (_hidden) {
            return null;
        }
        return (React.createElement(ContextMenuItem, { accessibilityLabel: t('toolbar.accessibilityLabel.privateMessage'), icon: IconNexusMessage, onClick: this._onClick, text: t('toolbar.privateMessage') }));
    }
    /**
     * Callback to be invoked on pressing the button.
     *
     * @param {React.MouseEvent|undefined} e - The click event.
     * @returns {void}
     */
    _onClick() {
        const { _participant, dispatch, notifyClick, notifyMode } = this.props;
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        dispatch(openChat(_participant));
    }
}
/**
 * Maps part of the Redux store to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @param {IProps} ownProps - The own props of the component.
 * @returns {IProps}
 */
function _mapStateToProps(state, ownProps) {
    const enabled = getFeatureFlag(state, CHAT_ENABLED, true) && !isChatDisabled(state);
    const { visible = enabled } = ownProps;
    return {
        _participant: getParticipantById(state, ownProps.participantID),
        visible,
        _hidden: (typeof interfaceConfig !== 'undefined'
            && (interfaceConfig.DISABLE_PRIVATE_MESSAGES || !isButtonEnabled('chat', state))) || isChatDisabled(state)
    };
}
export default translate(connect(_mapStateToProps)(PrivateMessageMenuButton));
